(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.service('InImageTypeCService', [
        '$http',
        '$q',
        function($http, $q) {
                this.getDefaultOptions = function() {
                    return {
						creativeWidth: '320',
						creativeHeight: '100',
						minWidth: 320,
						maxWidth: "100%",
						minHeight: 100,
						maxHeight: 100,
						closeActionTime: -1,
                    };

                };

            this.generateContent = function(scope, options){
                var template = ``;
                return template;
            };






        },
    ]);
})(window.angular);
